import { makeStyles } from '@material-ui/core'
const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(1),
  },
  column: {
    flexBasis: '5%',
  },
  accordionSummary: {
    '& .MuiAccordionSummary-content': {
      alignItems: 'center',
    },
  },
  avatar: {
    backgroundColor: theme.palette.primary.main,
  },
  link: {
    fontSize: theme.typography.pxToRem(16),
    color: theme.palette.text.primary,
  },
  originLink: {
    paddingLeft: '16px',
  },
  accordionActions: {
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'center',
  },
  delete: {
    color: theme.palette.primary.delete,
  },
}))
export default useStyles
